import { createContext} from "react";

export type Theme = "light" | "dark";

type ThemeContextType = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  forceThemeChange: (forcedTheme: Theme) => void;
  clearForcedTheme: () => void;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
